module.exports = __webpack_public_path__ + "static/media/03_APOTHEO_LABO_ALEPIA.a0335bc3.png";